import React from "react";
import { ReactSVG } from "react-svg";
var Svg = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? 20 : _width, _wrapper = param.wrapper, wrapper = _wrapper === void 0 ? "span" : _wrapper;
    return /*#__PURE__*/ React.createElement(ReactSVG, {
        src: src,
        beforeInjection: function(svg) {
            svg.setAttribute("style", "width: ".concat(width, "px"));
        },
        fallback: function() {
            return /*#__PURE__*/ React.createElement("span", null, "Error!");
        },
        loading: function() {
            return /*#__PURE__*/ React.createElement("span", null, "...");
        },
        wrapper: wrapper
    });
};
export default Svg;
